import PageHeader from 'components/common/PageHeader';
import AdvanceTablePagination from 'components/common/usersTable/AdvanceTablePagination';
import dayjs from 'dayjs';
import moment from 'moment';
import 'moment/locale/es';
import { useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchOfficesByUserId } from 'redux/branchOfficeSlice';
import { getSharedProperties } from 'redux/propsSlice';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import { informacion } from './propertyWizard/steps/data/props';
import ListFilterComponent from './tables/propertiesTable/components/ListFilterComponent';
import ListOrderComponent from './tables/propertiesTable/components/ListOrderComponent';
import SharedCards from './tables/propertiesTable/SharedCards';
import SelectShareBar from './tables/propertiesTable/components/SelectShareBar/SelectShareBar';

moment.locale('es');

export const propStatusObj = {
  pending: 'Pendiente',
  published: 'Activa',
  paused: 'Pausada',
  deleted: 'Eliminada',
  finished: 'Finalizada'
};

const Compartidas = () => {
  //Hooks e informacion base del usuario
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);
  const realEstate = useSelector(state => state.realEstate.realEstate);

  //Estado base
  const [data, setData] = useState();

  //Estado para oficina actual y lista de props
  const {
    sharedProps: properties,
    neighborhoodsObj,
    loading
  } = useSelector(state => state.props);

  // const [loading, setLoading] = useState(true);

  //Estados para paginacion
  const [page, setPage] = useState({ number: 1 });
  const [propsLimit, setPropsLimit] = useState(6);
  const [totalProps, setTotalProps] = useState(0);
  const [filtersAndSort, setFiltersAndSort] = useState({
    status: [],
    propertyTypes: [],
    operation: 0,
    shared: 'all',
    price: {
      min: '',
      max: '',
      currency: 'ARS'
    },
    surface: {
      min: '',
      max: '',
      type: 'totalSurface'
    },
    sortBy: {
      prop: 'updated_at',
      order: 'asc'
    },
    neighborhoods: [],
    realEstates: [],
    ambiences: [],
    bedrooms: [],
    bathrooms: [],
    garages: []
  });

  const [checkChanges, setCheckChanges] = useState(false);

  //Estado para búsqueda
  const [searchProp, setSearchProp] = useState('');
  const [searchAddress, setSearchAddress] = useState('');

  //filtrado y sort de propiedades mostradas
  const [filtredProps, setFiltredProps] = useState(properties?.list);

  const [type, setType] = useState('cards');

  // State con array de elementos seleccionados
  const [selected, setSelected] = useState([]);

  const canNextPage = Math.ceil(totalProps / propsLimit) > page.number;
  const canPreviousPage = page.number > 1;

  const nextPage = () => {
    setPage(prev => ({ number: prev.number + 1 }));
  };

  const previousPage = () => {
    setPage(prev => ({ number: prev.number - 1 }));
  };

  const submitSearch = value => setSearchProp(value);
  const submitSearchAddress = value => setSearchAddress(value);

  const HandleCheckbox = () => {
    if (selected.length > 0) setSelected([]);
    else
      setSelected(
        data.map(prop => ({
          id: prop.id,
          title: prop.title,
          status: prop.status,
          price: prop.price,
          ambiences: prop.characteristics.ambience,
          type: prop.type,
          real_estate: prop.real_estate,
          share: prop.share,
          neighborhood: prop.barrios
        }))
      );
  };

  //Get real estate
  useEffect(() => {
    if (userLogged) {
      dispatch(getBranchOfficesByUserId(userLogged.id));
      dispatch(getRealEstateByUserId(userLogged.id));
    }
  }, [userLogged]);

  useEffect(() => {
    setPage({ number: 1 });
    setCheckChanges(true);
  }, [filtersAndSort, propsLimit, searchProp, searchAddress]);

  //inicializo las dos listas de propiedades en base a la lista actual
  useEffect(() => {
    if (properties) {
      setFiltredProps(properties.list);
      setTotalProps(properties?.length);
    }
  }, [properties]);

  useEffect(() => {
    if (
      page &&
      filtersAndSort &&
      propsLimit &&
      checkChanges &&
      (realEstate?.id || userLogged.realEstateId) &&
      !loading
    ) {
      dispatch(
        getSharedProperties(
          filtersAndSort,
          page.number,
          propsLimit,
          searchProp,
          searchAddress,
          realEstate?.id ? realEstate.id : userLogged.realEstateId
        )
      );
    }
  }, [checkChanges]);

  useEffect(() => {
    if (filtredProps) {
      const array = filtredProps?.map(prop => {
        return {
          id: prop._id,
          title: prop.title,
          images: prop.images,
          address: `${prop.location.street} ${prop.location.number}`,
          barrios: neighborhoodsObj[prop.location.barrios?.at(-1)],
          price: `${
            prop.price?.total ? informacion.currency[prop.price.currency] : ''
          } ${
            prop.price?.total?.toLocaleString('en-US') || 'Sin precio asignado'
          }`,
          expenses: `${
            prop.price?.expenses
              ? informacion.currency[prop.price.expensesCurrency]
              : ''
          } ${prop.price?.expenses?.toLocaleString('en-US') || 'Sin expensas'}`,
          operation: `${informacion.operation[prop.operation_type]}`,
          updated_at: dayjs(prop.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          created_at: dayjs(prop.updated_at).format('DD/MM/YYYY HH:mm [hs]'),
          type: informacion.property[prop.property_type],
          share: prop.share,
          locality: prop.location.locality,
          characteristics: prop.characteristics,
          surface: prop.surface,
          real_estate: prop.real_estate,
          branch_office: prop.branch_office
        };
      });
      setCheckChanges(false);
      setData(array);
    }
  }, [filtredProps]);

  return (
    <>
      {userLogged && (
        <>
          <PageHeader
            title="Propiedades Compartidas"
            description="Listado de propiedades compartidas por otras inmobiliarias."
            className="mb-3 bg-white"
          />

          <Row className="g-3">
            <Col xs={12} lg={3} xxl={2}>
              <ListFilterComponent
                filtersAndSort={filtersAndSort}
                setFiltersAndSort={setFiltersAndSort}
                submitSearch={submitSearch}
                searching={!!searchProp}
                searchAddress={submitSearchAddress}
                searchingAddress={!!searchAddress}
                noBranchOffice
                noStatus
                noShared
                showCharacteristics
                neighborhoods={properties.neighborhoods}
                realEstates={properties.realEstates}
              />
            </Col>

            <Col xs={12} lg={9} xxl={10}>
              <Row className="g-1">
                <Col xs={12}>
                  <ListOrderComponent
                    type={type}
                    setType={setType}
                    page={page.number}
                    propsLimit={propsLimit}
                    setPropsLimit={setPropsLimit}
                    totalProps={totalProps}
                    filtersAndSort={filtersAndSort}
                    setFiltersAndSort={setFiltersAndSort}
                    rowsPerPageOptions={[6, 12, 18, 24, 32, 40]}
                    loading={loading}
                  />
                </Col>

                <Col xs={12}>
                  <SelectShareBar
                    selected={selected}
                    setSelected={setSelected}
                    handleCheckbox={HandleCheckbox}
                    type="property"
                  />
                </Col>

                <Col xs={12}>
                  {loading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '60vh'
                      }}
                    >
                      <Spinner
                        animation="border"
                        style={{
                          color: '#2c7be5'
                        }}
                      />
                    </div>
                  ) : (
                    data && (
                      <SharedCards
                        properties={data}
                        length={properties.length}
                        loading={loading}
                        propsLimit={propsLimit}
                        selected={selected}
                        setSelected={setSelected}
                      />
                    )
                  )}
                </Col>

                <Col xs={12} className="pt-2">
                  <AdvanceTablePagination
                    canNextPage={canNextPage}
                    canPreviousPage={canPreviousPage}
                    pageCount={Math.ceil(totalProps / propsLimit)}
                    gotoPage={page => setPage({ number: page + 1 })}
                    nextPage={nextPage}
                    pageIndex={page.number - 1}
                    previousPage={previousPage}
                    setCheckChanges={setCheckChanges}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default Compartidas;
